/**
 * CreditCardIcons.jsx
 * Created by Destin Frasier on 9/18/17.
 */

import CreditCardIconSingleton from './creditCardIconSingleton';
import BaseIcon from '../BaseIcon';


class CreditCardIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = CreditCardIconSingleton;
    }
}

export class CreditIconVisa extends CreditCardIcon {}
CreditIconVisa.defaultProps = {
    iconName: 'rec-icon-visa',
    iconClass: 'rec-icon-visa',
    alt: 'Visa'
};

export class CreditIconMasterCard extends CreditCardIcon {}
CreditIconMasterCard.defaultProps = {
    iconName: 'rec-icon-master-card',
    iconClass: 'rec-icon-master-card',
    alt: 'Master Card'
};

export class CreditIconDiscover extends CreditCardIcon {}
CreditIconDiscover.defaultProps = {
    iconName: 'rec-icon-discover',
    iconClass: 'rec-icon-discover',
    alt: 'Discover'
};

export class CreditIconAmex extends CreditCardIcon {}
CreditIconAmex.defaultProps = {
    iconName: 'rec-icon-amex',
    iconClass: 'rec-icon-amex',
    alt: 'American Express'
};

export class CreditIconJcb extends CreditCardIcon {}
CreditIconJcb.defaultProps = {
    iconName: 'rec-icon-jcb',
    iconClass: 'rec-icon-jcb',
    alt: 'JCB'
};

export class CreditIconUnionPay extends CreditCardIcon {}
CreditIconUnionPay.defaultProps = {
    iconName: 'rec-icon-union-pay',
    iconClass: 'rec-icon-union-pay',
    alt: 'Union Pay'
};
